<template>
    <section class="banner banner-bg" v-bind:style="{ backgroundImage: 'url('+ this.imagePath +''+ sliderData.slider_background +')' }">
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="row">
            <div class="columns col-12">
                <div class="top-pad">&nbsp;</div>
                <h1>
                    <strong>{{ sliderData.slider_title }} <br> {{ sliderData.slider_sub_title }}</strong>
                    <span> {{ sliderData.slider_sub_title_intro }}</span>
                </h1>
                <h2>
                    {{ sliderData.slider_sub_sub_title }}
                </h2>
                <router-link :to="{path:sliderData.slider_button_link}" class="button success shadow">
                    {{ sliderData.slider_button_title }}
                </router-link>
                <h2 class="mention-text">
                    <em>
                        {{ sliderData.slider_detail }}
                    </em>
                    <br>
                    <img class="mention-logo" :src="imagePath + sliderData.header_logo" width="100%" height="auto" alt="">
                </h2>
                <a href="#section_3" class="down" id="down">
                    <!-- <img src="../../assets/images/blank.gif" alt="Scroll down"> -->
                    <img src="../../assets/images/gbb-arrow.png" alt="Scroll down">
                </a>
                <div class="bot-pad">&nbsp;</div>
            </div>
        </div>
    </section>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    name: "SliderHome",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            sliderData: [],
            imagePath: this.$api + "upload/slider/"
        }
    },
    created() {
        this.slider();
    },
    methods: {
        slider: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/geek-slider"
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.sliderData = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        }
    }
}
</script>